import { render, staticRenderFns } from "./px-navbar-minimal.vue?vue&type=template&id=2e0b210f&scoped=true&"
import script from "./px-navbar-minimal.vue?vue&type=script&lang=ts&"
export * from "./px-navbar-minimal.vue?vue&type=script&lang=ts&"
import style0 from "./px-navbar-minimal.vue?vue&type=style&index=0&id=2e0b210f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0b210f",
  null
  
)

export default component.exports